<div class="uk-section-default uk-section uk-section-small uk-padding-remove-bottom" style="min-height: 600px">
  <div class="uk-container">
    <div class="uk-grid-margin uk-grid uk-grid-stack" uk-grid="">
      <div class="uk-width-1-1@m uk-first-column">

        <h1 class="uk-text-center">Error: Forbidden</h1>

        <div class="uk-container uk-margin-large-bottom">
          <div class="uk-grid">

            <!-- MIDDLE -->
            <div class=" uk-width-expand@m">

              <div style="font-size: 180px; color: #0055b9; line-height: 1.2;" class="uk-text-center">
                <strong>403</strong>
              </div>

              <div class="uk-text-center">
                Sorry, access to this {{serviceORresource | lowercase}} is forbidden.
              </div>
              <div class="uk-text-center">
                Either check the URL or <a href="/home">go back to the homepage</a>.
              </div>

            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</div>
